const about = {
  path: "/about",
  name: "about",
  redirect: "/aboutUs",
  component: () => import("@/views/about/index.vue"),
  title: "关于科云",
  children: [
    {
      path: "/about/dynamic",
      name: "dynamic",
      component: () => import("@/views/about/dynamic/index.vue"),
      title: "资讯动态"
    },
    {
      path: "/about/aboutUs",
      name: "aboutUs",
      component: () => import("@/views/about/aboutUs/index.vue"),
      title: "关于我们"
    },
    {
      path: "/about/joinUs",
      name: "joinUs",
      component: () => import("@/views/about/joinUs/index.vue"),
      title: "加入我们"
    },
    {
      path: "/about/contactUs",
      name: "contactUs",
      component: () => import("@/views/about/contactUs/index.vue"),
      title: "联系我们"
    }
  ]
};

export default about;
